import IconBox from '../../../components/common/icon-box'
import Button from '../../../components/common/button'
import { SubmitHandler, useForm } from 'react-hook-form'
import { ChangePasswordDto } from '@ringo/shared'
import { toast } from 'react-toastify'
import ControlledInputText from '../../../components/form/controlled-input-text'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from '../../../useTranslation'
import { object, string, ref } from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useValidationRules } from '../../../common/validation-rules'
import { Validation } from '../../../common/types'
import { useIamApi } from '../../../common/api-context'

const UpdatePassword = () => {
    const { t } = useTranslation()
    const validationRules = useValidationRules()
    const validationObject: Validation<ChangePasswordDto> = {
        newPassword: validationRules.password,
        confirmPassword: string()
            .required()
            .oneOf([ref('newPassword')], { key: 'createAccount.passwordsDontMatch' }),
        oldPassword: string().required(),
    }

    const schema = object(validationObject)
    const iamApi = useIamApi()
    const { handleSubmit, control } = useForm<ChangePasswordDto>({
        resolver: yupResolver(schema as any),
    })

    const mutation = useMutation({
        mutationFn: (formData: ChangePasswordDto) => {
            return iamApi.changePassword(formData)
        },
        onSuccess: () => {
            toast.success(t('myAccount.personalData.passwordUpdatedSuccessfully'))
        },
    })

    const onSubmit: SubmitHandler<ChangePasswordDto> = async (data) => {
        mutation.mutate(data)
    }

    return (
        <IconBox icon={'key'}>
            <div className="pt-12 pb-6 px-2 max-tablet:pt-10">
                <form className="" onSubmit={handleSubmit(onSubmit)}>
                    <p className="font-bold text-xl text-left mb-3 max-tablet:text-base max-tablet:mb-2">{t('password')}</p>
                    <div className="flex flex-col mb-3">
                        <div className="w-full mb-3">
                            <ControlledInputText
                                control={control}
                                label={t('myAccount.personalData.newPassword')}
                                name="newPassword"
                                type="password"
                                required
                            />
                        </div>
                        <div className="w-full mb-3">
                            <ControlledInputText control={control} label={t('confirmPassword')} name="confirmPassword" type="password" required />
                        </div>
                        <div className="w-full">
                            <ControlledInputText
                                control={control}
                                label={t('myaccount.personalData.currentPassword')}
                                name="oldPassword"
                                type="password"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex justify-center mt-14 max-tablet:mt-5">
                        <Button type="squareBlue" icon="check" text={t('save')} isLoading={mutation.isPending} />
                    </div>
                </form>
            </div>
        </IconBox>
    )
}

export default UpdatePassword
